import { PropsWithChildren } from 'react';
import { PersonTypes } from '@frontend/api-person';
import { FloatingActionBar } from '@frontend/adapto-actions';
import { Actions } from '@frontend/contact-actions';
import { useTranslation } from '@frontend/i18n';

interface Props {
  locationId: string;
  person: PersonTypes.Person;
}

export const AppointmentFloatingActions = ({ person, locationId, children }: PropsWithChildren<Props>) => {
  const { t } = useTranslation('schedule');
  const personId = person.PersonID;
  return (
    <FloatingActionBar>
      <FloatingActionBar.Actions>
        <Actions.Message context={{ personId, locationId }} label={t('Send Message')} />
        <Actions.Call context={{ personId, locationId }} label={t('Click to Call')} />
        <Actions.Payments context={{ personId, locationId }} label={t('Request Payments')} />
        <Actions.SendForm context={{ person, locationId }} label={t('Send Form')} />
      </FloatingActionBar.Actions>
      <FloatingActionBar.Content>{children}</FloatingActionBar.Content>
    </FloatingActionBar>
  );
};
